module.exports = __webpack_public_path__ + "5ab4dff22cf159c5bb8d6ea0edb6bb15.svg";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/apps/dashboard/dashboard-banner.svg
// module id = 380
// module chunks = 7